import { render } from "./SocialPost.vue?vue&type=template&id=92bdb46c&scoped=true"
import script from "./SocialPost.vue?vue&type=script&lang=js"
export * from "./SocialPost.vue?vue&type=script&lang=js"

import "./SocialPost.vue?vue&type=style&index=0&id=92bdb46c&lang=scss"
import "./SocialPost.vue?vue&type=style&index=1&id=92bdb46c&lang=scss&scoped=true"
import "./SocialPost.vue?vue&type=style&index=2&id=92bdb46c&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bdb46c"]])

export default __exports__